import { useQuery } from "@tanstack/react-query";
import { bankInfoQueryApi } from "@/shared/api/bank-info/query";
import { BuyerRemitterNameResponse } from "@/shared/api/bank-info/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

export const buyerRemitterNameQueryKey = "buyer-remitter-name";

// 바이어 기본 입금자명 조회 훅 — 패스픽 주문·멤버십 신청에 마지막으로 적은 입금자명이다.
// 한 번도 적은 적이 없으면 null 이고, 그때 입력 칸은 빈 칸으로 둔다(회사명을 대신 채우지 않는다).
// 주문·신청이 접수되면 서버가 값을 바꾸므로 그때 이 쿼리를 무효화한다.
const useGetBuyerRemitterName = () => {
  const { companyId } = useCompanyIdentity();

  const { data, isPending } = useQuery({
    queryKey: [buyerRemitterNameQueryKey, companyId],
    queryFn: () => bankInfoQueryApi.getBuyerRemitterName(companyId as number),
    select: (response) =>
      toCamelKeyObject(response) as BuyerRemitterNameResponse,
    enabled: Boolean(companyId),
  });

  return { remitterName: data?.remitterName ?? null, isPending };
};

export default useGetBuyerRemitterName;
